import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const darkGray = '#777';
const lightGray = '#ccc';
// Light theme
const ltBlueLink = '#00f';
const ltPreBackground = '#f8f8f8';
// Dark theme
const dtBlueLink = '#1A91DA';
const dtPreBackground = '#4f4f4f';

export const HomeUl = styled.ul`
  margin-left: 2rem;
  list-style-type: none;

  li {
    font-size: 2rem;
    line-height: 2.2rem;
    margin: 2rem 0;
  }
`;

export const Date = styled.span`
  color: ${darkGray};
`;

export const Title = styled.h1`
  font-size: 3rem;
  line-height: 3.2rem;
  font-weight: normal;
  margin-bottom: 2rem;
`;

export const Subtitle = styled.h2`
  margin-top: -1.5rem;
  font-size: 2.2rem;
  line-height: 2.4rem;
  font-weight: normal;
  color: ${darkGray};
  margin-bottom: 2rem;
`;

export const H1 = styled.h1`
  font-size: 3rem;
  line-height: 3.2rem;
  font-weight: strong;
  margin-bottom: 2rem;
`;

export const H2 = styled.h2`
  margin-top: 2rem;
  font-size: 2.2rem;
  line-height: 2.4rem;
  font-weight: strong;
  margin-bottom: 2rem;
`;

export const BookH2 = styled.h2`
  margin-top: 2rem;
  font-size: 2.2rem;
  line-height: 2.4rem;
  font-weight: strong;
  margin-bottom: 2rem;
  cursor: pointer;
  text-decoration: none;
  transition: text-decoration 0.2s;

  &:hover {
    text-decoration: underline;
  }
`;

export const Blockquote = styled.blockquote`
  border-left: 1px solid ${lightGray};
  padding-left: 1em;
  font-size: 2rem;
  line-height: 2.7rem;
  margin: 2rem 0 2rem 2rem;
`;

export const Ul = styled.ul`
  margin-left: 2.6rem;

  li {
    font-size: 2rem;
    line-height: 2.7rem;
    margin: 2rem 0;
  }
`;

export const Ol = styled.ol`
  margin-left: 3.2rem;

  li {
    font-size: 2rem;
    line-height: 2.7rem;
    margin: 2rem 0;
  }
`;

export const Navigation = styled.nav`
  font-size: 2rem;
  line-height: 2.7rem;
  margin-bottom: 3rem;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  ul li {
    padding: 1.5rem 1.5rem 1.5rem 0;
    display: inline;
  }

  a {
    text-decoration: none;
    position: relative;
  }

  a:link {
    color: ${darkGray} !important;
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }

  a:visited {
    color: ${darkGray} !important;
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }

  a:hover {
    color: ${darkGray} !important;
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }
`;

export const Div = styled.div`
  max-width: ${window.screen.width - 30}px;

  strong {
    font-weight: 700;
  }

  a {
    text-decoration: none;
    position: relative;
  }

  a:link {
    color: ${ltBlueLink};
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }

  a:visited {
    color: ${ltBlueLink};
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }

  a:hover {
    color: ${ltBlueLink};
    @media (prefers-color-scheme: dark) {
       color: ${dtBlueLink};
     }
  }

  p {
    font-size: 2rem;
    line-height: 2.7rem;
    margin: 2rem 0;
  }

  code,
  pre {
    font: 1.8rem/2rem "Courier New", Courier, monospace;
    background: ${ltPreBackground};
    overflow: auto;
    white-space: pre-wrap;
    @media (prefers-color-scheme: dark) {
      background: ${dtPreBackground};
    }
  }
`;

export const Nav = props => {
  return (
    <Navigation>
      <ul>
        <li>
          <Link to="/">
            <strong>Duane Hilton</strong>
          </Link>
        </li>
        <li>
          <Link to="/notes/">Notes</Link>
        </li>
        <li>
          <Link to="/books/">Books</Link>
        </li>
      </ul>
    </Navigation>
  );
};

export const Error = props => {
  return (
    <Div>
      <Nav />
      <p>Error!</p>
      <p>
        Here's a link to the <a href="/">homepage</a>.
      </p>
    </Div>
  );
};
